export function unwrapRegionsIndexPayload(raw_payload) {
  if (raw_payload == null) return []
  if (Array.isArray(raw_payload)) return raw_payload
  if (Array.isArray(raw_payload.data)) return raw_payload.data
  if (Array.isArray(raw_payload.regions)) return raw_payload.regions
  return []
}

/** Mesmo id pode aparecer em mais de um fragmento; mantém o caminho mais completo (mais ancestrais). */
export function dedupeRegionRowsPreferDeepestPath(rows) {
  let by_id = new Map()
  for (let row of rows || []) {
    let id = Number(row.id)
    if (Number.isNaN(id)) continue
    let previous_row = by_id.get(id)
    let depth = (row.ancestor_ids && row.ancestor_ids.length) || 0
    let previous_depth = previous_row && previous_row.ancestor_ids ? previous_row.ancestor_ids.length : -1
    if (!previous_row || depth > previous_depth) by_id.set(id, row)
  }
  return [...by_id.values()]
}

/**
 * Converte a árvore retornada por GET /regions (arrange_serializable) em lista achatada.
 */
export function flattenRegionsTree(data) {
  let flattened_rows = []
  let walkTree = (current_node, depth_level, ancestor_names, ancestor_ids) => {
    if (current_node == null) return

    if (Array.isArray(current_node)) {
      current_node.forEach((child_node) => walkTree(child_node, depth_level, ancestor_names, ancestor_ids))
      return
    }

    if (typeof current_node === 'object' && current_node.id != null && current_node.name != null) {
      let path_label = ancestor_names.length
        ? `${ancestor_names.join(' › ')} › ${current_node.name}`
        : current_node.name

      flattened_rows.push({
        id: Number(current_node.id),
        name: current_node.name,
        kind: current_node.kind,
        code: current_node.code != null ? String(current_node.code) : '',
        depth: depth_level,
        path_label,
        /** IDs dos ancestrais (do país até o pai direto), para expandir a árvore na busca */
        ancestor_ids: [...ancestor_ids],
      })

      let next_ancestor_names = [...ancestor_names, current_node.name]
      let next_ancestor_ids = [...ancestor_ids, Number(current_node.id)]

      if (Array.isArray(current_node.children) && current_node.children.length) {
        current_node.children.forEach((child_node) => walkTree(child_node, depth_level + 1, next_ancestor_names, next_ancestor_ids))
      }
    }
  }

  walkTree(data, 0, [], [])
  return flattened_rows
}

/**
 * A partir das linhas que deram match na busca, define quais nós expandir (raiz + filhos ao longo do caminho).
 * Retorna objetos serializáveis (sem Set).
 */
export function buildAncestorExpandPlan(match_rows) {
  let root_ids_to_expand = new Set()
  let children_to_expand_by_parent_id = {}

  for (let matched_row of match_rows) {
    let ancestor_ids = (matched_row.ancestor_ids || []).map((id) => Number(id))
    let full_chain_ids = [...ancestor_ids, Number(matched_row.id)]

    if (full_chain_ids.length >= 1) root_ids_to_expand.add(full_chain_ids[0])

    for (let chain_index = 0; chain_index < full_chain_ids.length - 1; chain_index++) {
      let parent_id = full_chain_ids[chain_index]
      let child_id = full_chain_ids[chain_index + 1]
      let parent_key = String(parent_id)

      if (!children_to_expand_by_parent_id[parent_key]) children_to_expand_by_parent_id[parent_key] = new Set()
      children_to_expand_by_parent_id[parent_key].add(child_id)
    }
  }

  let expand_children_under_parent = {}
  Object.keys(children_to_expand_by_parent_id).forEach((parent_key) => {
    expand_children_under_parent[parent_key] = [...children_to_expand_by_parent_id[parent_key]].map((id) => Number(id))
  })

  return {
    expand_root_ids: [...root_ids_to_expand].map((id) => Number(id)),
    expand_children_under_parent,
  }
}

/** Lista { id, name, kind } para selects (fretes e formulários). */
export function flattenRegionsForSelect(tree_data) {
  return flattenRegionsTree(tree_data).map((row) => ({ id: row.id, name: row.name, kind: row.kind }))
}
